var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LeadStatusesPage',{attrs:{"title":"Bloqueio - Automatização","description":"Define quais status são bloqueados para automatização","param-id":"leads_block_statuses_automation"}})
}
var staticRenderFns = []

export { render, staticRenderFns }